import type { CreateProfessionInput, UpdateProfessionInput } from '@idc-forms/schemas'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import {
  createProfession,
  deleteProfession,
  updateProfession
} from '../services/professions-admin.service'

export const useCreateProfessionMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: CreateProfessionInput) => await createProfession(payload),
    onSuccess: () => {
      toast.success('Profesión creada')
      void queryClient.invalidateQueries({ queryKey: queryKeys.professions.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useUpdateProfessionMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: UpdateProfessionInput }) =>
      await updateProfession(id, payload),
    onSuccess: () => {
      toast.success('Profesión actualizada')
      void queryClient.invalidateQueries({ queryKey: queryKeys.professions.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useDeleteProfessionMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => await deleteProfession(id),
    onSuccess: () => {
      toast.success('Profesión eliminada')
      void queryClient.invalidateQueries({ queryKey: queryKeys.professions.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}
